const isLetter = (character: string): boolean => character.toLocaleLowerCase() !== character.toLocaleUpperCase()

export const isPasswordCompositionValid = (password: string): boolean => {
    const characters = password.split('')
    const hasLetter = characters.some(isLetter)
    const hasNumber = /[0-9]/.test(password)
    const hasSpecialCharacter = characters.some((character) => !isLetter(character) && !/[0-9\s]/.test(character))

    return hasLetter && hasNumber && hasSpecialCharacter
}
